<template>
    <div class="flex cursor-pointer justify-between space-x-4" @click="markAsRead">
        <div class="shrink-0">
            <Avatar :src="fromUser.avatar" :alt="fromUser.tag_name" />
        </div>
        <div class="flex-1">
            <div class="flex items-start justify-between">
                <div class="flex-1">
                    <p class="mt-1 text-sm">
                        {{ notificationMessage }}
                    </p>
                </div>
                <span class="text-titles ml-4 text-sm font-bold">
                    {{ formattedDate }}
                </span>
            </div>

            <div class="mt-4">
                <DiagonalCutButton variant="primary" cut-position="right-top" disabled>
                    {{ $t('notifications.match_accepted_status') }}
                </DiagonalCutButton>
            </div>
        </div>
    </div>
</template>

<script>
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'
import Avatar from '@/components/Avatar.vue'
import { formatRelativeTime } from '@/utils/dateHelpers.js'
import { matchTypeName } from '@/constants/matchTypes.js'

export default {
    name: 'MatchInviteAcceptedNotification',

    components: {
        DiagonalCutButton,
        Avatar,
    },

    props: {
        notification: {
            type: Object,
            required: true,
        },
    },

    emits: ['read'],

    computed: {
        fromUser() {
            return {
                tag_name:
                    this.notification?.data?.from_user?.tag_name ||
                    this.notification?.data?.from_user?.name ||
                    this.$t('notifications.unknown_user'),
                avatar: this.notification?.data?.from_user?.avatar,
            }
        },

        notificationMessage() {
            const name = this.fromUser.tag_name
            const matchType = matchTypeName(
                this.notification?.data?.match?.matchtype_id,
                this.notification?.data?.match?.matchtype_name || null,
            )
            return matchType
                ? this.$t('notifications.match_accepted_body', { name, matchType })
                : this.$t('notifications.match_accepted_body_generic', { name })
        },

        formattedDate() {
            return formatRelativeTime(this.notification.created_at)
        },

        isRead() {
            return !!this.notification.read_at
        },
    },

    methods: {
        markAsRead() {
            this.$emit('read', this.notification)
        },
    },
}
</script>
